import { render, staticRenderFns } from "./DiseasesBarChart.vue?vue&type=template&id=11ec1311"
import script from "./DiseasesBarChart.vue?vue&type=script&lang=js"
export * from "./DiseasesBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports